import { render, staticRenderFns } from "./Bundle.vue?vue&type=template&id=47daff9a"
import script from "./Bundle.vue?vue&type=script&lang=js"
export * from "./Bundle.vue?vue&type=script&lang=js"
import style0 from "./Bundle.vue?vue&type=style&index=0&id=47daff9a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports